import React, { useState } from "react";
import Logo from "../assets/images/logo.png";
import { Link } from "react-router-dom"; // Importing Link from react-scroll for smooth scrolling

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const navItems = [
    { label: "Home", href: "/" },
    { label: "Purpose of the Website", href: "purpose-of-website" },
    { label: "Our Mission", href: "our-mission" },
    { label: "250+ Country Meme Zones", href: "country-meme-zones" },
    { label: "SEO Command", href: "seo-command" },
  ];

  return (
    <nav className="bg-white border-t-4 border-b-4 border-[#006600] font-orbitron shadow-md fixed top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex justify-between items-center">
        {/* Logo Left-Aligned */}
          <div className="flex items-center space-x-3">
        <Link to="/" className="text-description-none">
            <img src={Logo} alt="Logo" className="h-10 md:h-20 w-auto" />
        </Link>
          </div>

        {/* Hamburger (Mobile) */}
        <div className="md:hidden">
          <button
            onClick={() => setOpen(!open)}
            className="text-[#003300] focus:outline-none"
          >
            <svg
              className="w-7 h-7"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d={open ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
              />
            </svg>
          </button>
        </div>

        {/* Desktop Menu (Right-Aligned) */}
        <ul className="hidden md:flex items-center space-x-8 uppercase tracking-wider text-sm font-bold text-[#003300]">
          {navItems.map(({ label, href }) => (
            <li key={label}>
              <Link
                to={href}
                smooth={true}
                duration={500}
                className="hover:text-[#00FF99] hover:underline underline-offset-4 transition-all duration-200"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Mobile Dropdown */}
      {open && (
        <ul className="md:hidden bg-white px-6 pt-2 pb-4 space-y-3 uppercase text-sm font-semibold text-[#003300] border-t border-gray-200">
          {navItems.map(({ label, href }) => (
            <li key={label}>
              <Link
                to={href}
                smooth={true}
                duration={500}
                onClick={() => setOpen(false)} // Close the dropdown on mobile when a link is clicked
                className="block hover:text-[#00FF99] hover:underline underline-offset-2 transition duration-200"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
